import React, { useEffect, useState, useCallback } from 'react';
import { userAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import '../styles/Rewards.css';

export default function ReferralDashboard() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await userAPI.getReferralData();
      setData(res.data);
    } catch {
      // ignore
    }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const referralLink = data?.referral_code
    ? `${window.location.origin}/register?ref=${data.referral_code}`
    : '';

  const handleCopy = () => {
    if (!referralLink) return;
    navigator.clipboard.writeText(referralLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {});
  };

  if (loading) return <div className="rewards-page"><p className="rewards-loading">Loading...</p></div>;

  return (
    <div className="rewards-page">
      <h1 className="rewards-title">Referral Dashboard</h1>

      <div className="referral-stats">
        <div className="ref-stat-card">
          <div className="ref-stat-icon">🤝</div>
          <div className="ref-stat-value">{data?.referral_count || 0}</div>
          <div className="ref-stat-label">Friends Referred</div>
        </div>
        <div className="ref-stat-card">
          <div className="ref-stat-icon">💰</div>
          <div className="ref-stat-value">{data?.earned_from_referrals || 0}</div>
          <div className="ref-stat-label">WP Earned</div>
        </div>
      </div>

      <div className="referral-link-section">
        <h3>Your Referral Link</h3>
        <div className="referral-link-box">
          <input
            type="text"
            value={referralLink}
            readOnly
            className="referral-link-input"
          />
          <button className="referral-copy-btn" onClick={handleCopy}>
            {copied ? '✅ Copied!' : '📋 Copy'}
          </button>
        </div>
        <p className="referral-code-display">
          Code: <strong>{data?.referral_code || '—'}</strong>
        </p>
        <p className="referral-info">
          Share your link with friends. When they sign up and make their first deposit, you earn a 10% bonus!
        </p>
      </div>

      {data?.referred_users?.length > 0 && (
        <div className="referral-users-section">
          <h3>Referred Users</h3>
          <table className="history-table">
            <thead>
              <tr>
                <th>Username</th>
                <th>Joined</th>
                <th>Verified</th>
              </tr>
            </thead>
            <tbody>
              {data.referred_users.map((u) => (
                <tr key={u.id}>
                  <td>{u.username}</td>
                  <td>{new Date(u.created_at).toLocaleDateString()}</td>
                  <td>{u.is_email_verified ? '✅' : '❌'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
